import * as React from "react";
import { EvaluationDetailPage } from "..";
import { ETLCodes } from "../../../locales";
import { ERoutes } from "../../../ERoutes";
import { ECommissionType, DysplasiaApi } from "../../../api";
import { useTl, useApiService } from "../../../hooks";
import { PageBase } from "../../../components";
import { useApiEffect } from "nsitools-react";
import { useParams, useHistory } from "react-router";
import { ProtectedTabs, BackButton } from "../../../components";
import { Tab, Spinner } from "@blueprintjs/core";

export interface IComissionDysplasiaItemPageProps {}

export const ComissionDysplasiaItemPage: React.FunctionComponent<IComissionDysplasiaItemPageProps> = (props) => {
  const { t } = useTl();
  const { id, tab, state } = useParams<{ id: string; tab: string; state: string }>();
  const history = useHistory();
  const api = useApiService(DysplasiaApi);
  const [pageInfo, loading] = useApiEffect(() => api.getComissionPageInfo(+id), [id]);
  const backRoute = React.useMemo(
    () =>
      pageInfo?.isAppeal
        ? ERoutes.appealDysplasia
        : pageInfo?.commissionType === ECommissionType.GentCommission
        ? ERoutes.gentCommission
        : ERoutes.commissionDysplasia,
    [pageInfo]
  );

  const BreadCrumbTitle = React.useMemo(
    () =>
      pageInfo?.isAppeal
        ? ETLCodes.Appeal
        : pageInfo?.commissionType === ECommissionType.GentCommission
        ? ETLCodes.GentCommission
        : ETLCodes.Commission,
    [pageInfo]
  );

  return loading ? (
    <Spinner />
  ) : (
    <PageBase
      breadCrumbs={[
        {
          text: t(BreadCrumbTitle),
          route: backRoute,
        },
        {
          text: pageInfo?.displayName,
        },
      ]}
    >
      <ProtectedTabs
        id="ComissionTabs"
        onChange={(newTabId) => history.push(`${backRoute}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={backRoute}/>
        <Tab
          id="evaluation"
          title={t(ETLCodes.Evaluation)}
          panel={
            <EvaluationDetailPage
              route={backRoute}
              isAppeal={pageInfo?.isAppeal}
              comissionType={pageInfo?.commissionType}
            />
          }
        />
      </ProtectedTabs>
    </PageBase>
  );
};
